import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import noop from "lodash/noop";
import React from "react";
import ResizeObserver from "resize-observer-polyfill";
import getNewWidths from "../getNewWidths/index.js";
const useResizeObserver = (_ref, _ref2) => {
  let {
    minSlideWidth,
    maxSlideWidth,
    gutter,
    responsive
  } = _ref;
  let {
    containerRef,
    totalSlidesCount
  } = _ref2;
  const [slideWidth, setSlideWidth] = React.useState(0);
  const [maskWidth, setMaskWidth] = React.useState(0);
  const [containerWidth, setContainerWidth] = React.useState(0);
  const resizeObserver = React.useRef();
  const animationFrameID = React.useRef();
  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return noop;
    }
    const updateWidthData = () => {
      const newWidths = getNewWidths({
        minSlideWidth,
        maxSlideWidth,
        gutter,
        responsive
      }, containerRef);
      setSlideWidth(newWidths.slideWidth);
      setMaskWidth(newWidths.maskWidth);
      setContainerWidth(newWidths.containerWidth);
    };
    resizeObserver.current = new ResizeObserver(() => {
      _globalThis.cancelAnimationFrame(animationFrameID.current);
      animationFrameID.current = _globalThis.requestAnimationFrame(() => {
        updateWidthData();
      });
    });
    resizeObserver.current.observe(container);
    updateWidthData();
    return () => {
      resizeObserver.current.unobserve(container);
      _globalThis.cancelAnimationFrame(animationFrameID.current);
    };
  }, [containerRef, minSlideWidth, maxSlideWidth, gutter, responsive]);
  return React.useMemo(() => {
    const visibleSlideSlots = slideWidth && maskWidth && Math.floor(maskWidth / slideWidth) || 0;
    const visibleSlidesCount = Math.min(visibleSlideSlots, totalSlidesCount);
    const takenSlideSpace = visibleSlidesCount * slideWidth;
    const extraPixels = containerWidth - takenSlideSpace;
    return {
      slideWidth,
      containerWidth,
      maskWidth,
      visibleSlideSlots,
      visibleSlidesCount,
      extraPixels
    };
  }, [slideWidth, containerWidth, maskWidth, totalSlidesCount]);
};
export default useResizeObserver;